import type { IntlShape } from 'react-intl';

import { EntityType, Operation } from './types';

export const getOptionLabels = (
  intl: IntlShape,
): {
  operationOptions: { value: Operation; label: string }[];
  entityOptions: { value: EntityType; label: string }[];
} => {
  const operations: Record<Operation, { label: string; value: Operation }> = {
    CREATE: {
      label: intl.formatMessage({
        id: 'AuditLogs.createLabel',
        defaultMessage: 'Create',
        description: 'Label for create operation option',
      }),
      value: 'CREATE' as Operation,
    },
    DEACTIVATE: {
      label: intl.formatMessage({
        id: 'AuditLogs.deactivateLabel',
        defaultMessage: 'Deactivate',
        description: 'Label for deactivate operation option',
      }),
      value: 'DEACTIVATE' as Operation,
    },

    DELETE: {
      label: intl.formatMessage({
        id: 'AuditLogs.deleteLabel',
        defaultMessage: 'Delete',
        description: 'Label for delete operation option',
      }),
      value: 'DELETE' as Operation,
    },
    DOWNLOAD: {
      label: intl.formatMessage({
        id: 'AuditLogs.downloadLabel',
        defaultMessage: 'Download',
        description: 'Label for download operation option',
      }),
      value: 'DOWNLOAD' as Operation,
    },
    EDIT: {
      label: intl.formatMessage({
        id: 'AuditLogs.editLabel',
        defaultMessage: 'Edit',
        description: 'Label for edit operation option',
      }),
      value: 'EDIT' as Operation,
    },
    FIELD_CHANGE: {
      label: intl.formatMessage({
        id: 'AuditLogs.fieldChangeLabel',
        defaultMessage: 'Field Change',
        description: 'Label for field change operation option',
      }),
      value: 'FIELD_CHANGE' as Operation,
    },
    LOGIN: {
      label: intl.formatMessage({
        id: 'AuditLogs.loginLabel',
        defaultMessage: 'Login',
        description: 'Label for login operation option',
      }),
      value: 'LOGIN' as Operation,
    },
    LOGOUT: {
      label: intl.formatMessage({
        id: 'AuditLogs.logoutLabel',
        defaultMessage: 'Logout',
        description: 'Label for logout operation option',
      }),
      value: 'LOGOUT' as Operation,
    },
    SECURITY: {
      label: intl.formatMessage({
        id: 'AuditLogs.securityLabel',
        defaultMessage: 'Security',
        description: 'Label for security operation option',
      }),
      value: 'SECURITY' as Operation,
    },

    TERMINATE: {
      label: intl.formatMessage({
        id: 'AuditLogs.terminateLabel',
        defaultMessage: 'Terminate',
        description: 'Label for terminate operation option',
      }),
      value: 'TERMINATE' as Operation,
    },
    VIEW: {
      label: intl.formatMessage({
        id: 'AuditLogs.viewLabel',
        defaultMessage: 'View',
        description: 'Label for view operation option',
      }),
      value: 'VIEW' as Operation,
    },
  };

  const entities: Record<
    EntityType,
    {
      label: string;
      value: EntityType;
    }
  > = {
    DOCUMENT: {
      label: intl.formatMessage({
        id: 'AuditLogs.documentLabel',
        defaultMessage: 'Document',
        description: 'Label for document operation option',
      }),
      value: 'DOCUMENT' as EntityType,
    },
    FOLDER: {
      label: intl.formatMessage({
        id: 'AuditLogs.folderLabel',
        defaultMessage: 'Folder',
        description: 'Label for folder operation option',
      }),
      value: 'FOLDER' as EntityType,
    },
    USER: {
      label: intl.formatMessage({
        id: 'AuditLogs.userLabel',
        defaultMessage: 'User',
        description: 'Label for user operation option',
      }),
      value: 'USER' as EntityType,
    },
  };

  const operationOptions = Object.entries(operations).map(([key, option]) => ({
    value: key as Operation,
    label: option.label,
  }));

  const entityOptions = Object.entries(entities).map(([key, option]) => ({
    value: key as EntityType,
    label: option.label,
  }));

  return { operationOptions, entityOptions };
};
